import * as _ from 'lodash';
import valueFilters from '../valueFilters';
import validator from '../validator';
import modelFactory, { IModel } from '../modelFactory';
import model from './model';

export interface IJobIssueAdditionalInfo extends IModel {
	name?: string;
	value?: string;
}

const jobIssueAdditionalInfoFactory = modelFactory.createFactory<IJobIssueAdditionalInfo>('JobIssueAdditionalInfo', _.assign({}, model, {
	name: {
		rules: validator.string()
	},
	value: {
		setFilters: valueFilters.toString,
		rules: validator.string()
	}
}));

export default jobIssueAdditionalInfoFactory;